<section class="launch-card">
  @if (loading()) {
    <mat-spinner diameter="40"></mat-spinner>
    <h1>Starte Salesforce Sitzung</h1>
    <p>Der Termin wird vorbereitet.</p>
  } @else if (errorMessage()) {
    <h1>Sitzung konnte nicht gestartet werden</h1>
    <p>{{ errorMessage() }}</p>
  }
</section>
